import { NgModule } from '@angular/core';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { MobilePassComponent } from './mobile-pass.component';
import { CommonModule } from '@angular/common';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';

@NgModule({
  declarations: [MobilePassComponent],
  imports: [
    CommonModule,
    PipesModule,
    LoadingModule,
    FGBSharedModule
  ],
  exports: [MobilePassComponent],
})
export class MobilePassModule {}
